import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationRepository } from 'src/app/core/data/repository';
import { UserPermissionService } from 'src/app/core/services/user-permission-service';
import { RoutesConstants } from '../common';
import { ApplicationType, Permissions } from 'src/app/core/common';
import { AuthUser } from 'src/app/core/data/model/auth-user-model';
import { NavBarService } from '../services/nav-bar.service';
import { SideMenuItem } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class HomePageGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationRepository: AuthenticationRepository,
    private userPermissionService: UserPermissionService,
    private navBarService: NavBarService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const sideNavMenuItems = this.navBarService.getSideNavItems();
    const currentUser = this.authenticationRepository.currentUser$.value;
    const isWhiteLabelUser = this.checkWhiteLabelUser(currentUser); 
    const userHasPermission = this.userPermissionService.isHasPermission(route.data['permissions']);
    const userHasStatisticsPermission = this.userPermissionService.isHasPermission([Permissions.Statistics]);

    if (userHasPermission) {
      return true;
    }

    if (isWhiteLabelUser && userHasStatisticsPermission) {
      this.router.navigate([RoutesConstants.DASHBOARD_WL_PAGE_URL]);
      return false;
    }

    this.navigateToNearestAccessibleRoute(sideNavMenuItems);
    return false;
  }

  navigateToNearestAccessibleRoute(menuItems: SideMenuItem[]): void {
    for (let menuItem of menuItems) {
      if (menuItem.isVisible) {
        if (menuItem.routerLink) {
          this.router.navigate([menuItem.routerLink]);
          break;
        } else if (menuItem.children.length > 0) {
          let visibleSubMenuItem = menuItem.children.find((item) => item.isVisible);
          if (visibleSubMenuItem) {
            this.router.navigate([visibleSubMenuItem.routerLink]);
            break;
          }
        }
      }
    }
  }

  checkWhiteLabelUser(currentUser: AuthUser): boolean {
    return (
      currentUser.appsType.length > 0 &&
      !currentUser.appsType.some((app) => app == ApplicationType.MODDAKIR || app == ApplicationType.MODDAKIR_KIDS)
    );
  }
}
